function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAws(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "700px",
    height: "216px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.991
    },
    fill: "#232f3e",
    d: "M -0.5,-0.5 C 232.833,-0.5 466.167,-0.5 699.5,-0.5C 699.5,71.5 699.5,143.5 699.5,215.5C 466.167,215.5 232.833,215.5 -0.5,215.5C -0.5,143.5 -0.5,71.5 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7f7f8",
    d: "M 335.5,53.5 C 338.5,53.5 341.5,53.5 344.5,53.5C 344.667,72.5029 344.5,91.5029 344,110.5C 340.229,112.276 337.062,111.609 334.5,108.5C 316.631,115.98 307.297,109.98 306.5,90.5C 306.471,79.0454 311.971,72.3787 323,70.5C 327.018,70.2848 330.685,71.2848 334,73.5C 334.205,66.7536 334.705,60.0869 335.5,53.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8f8f9",
    d: "M 384.5,54.5 C 384.17,61.1998 384.503,67.8665 385.5,74.5C 386.107,74.3764 386.44,74.0431 386.5,73.5C 402.565,66.7036 411.565,72.0369 413.5,89.5C 413.949,106.566 405.949,113.733 389.5,111C 387.714,110.215 386.214,109.049 385,107.5C 383.812,108.563 383.312,109.897 383.5,111.5C 380.881,111.768 378.381,111.435 376,110.5C 375.5,91.5029 375.333,72.5029 375.5,53.5C 378.713,53.19 381.713,53.5233 384.5,54.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#91979f",
    d: "M 384.5,54.5 C 385.167,60.8333 385.833,67.1667 386.5,73.5C 386.44,74.0431 386.107,74.3764 385.5,74.5C 384.503,67.8665 384.17,61.1998 384.5,54.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7f7f8",
    d: "M 504.5,58.5 C 509.511,58.3341 514.511,58.5007 519.5,59C 526.743,60.6515 530.909,65.1515 532,72.5C 532.14,84.3004 532.807,95.9671 534,107.5C 528.86,112.131 525.194,111.131 523,104.5C 516.463,111.042 508.629,113.209 499.5,111C 489.793,104.721 487.96,96.5548 494,86.5C 502.31,80.0928 511.477,78.7594 521.5,82.5C 522.773,78.4499 522.606,74.4499 521,70.5C 516.098,66.8201 510.598,65.6534 504.5,67C 501.061,68.0897 497.727,69.2564 494.5,70.5C 494.187,67.7531 494.52,65.0865 495.5,62.5C 498.482,60.836 501.482,59.5027 504.5,58.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f7f7",
    d: "M 622.5,58.5 C 629.327,58.1241 635.994,58.9574 642.5,61C 644.314,63.4815 644.98,66.3148 644.5,69.5C 638.055,67.0456 631.388,66.2123 624.5,67C 619.586,70.1705 619.253,73.8372 623.5,78C 627.232,80.1327 631.232,81.4661 635.5,82C 648.034,86.747 650.867,94.9137 644,106.5C 634.577,113.177 624.41,114.344 613.5,110C 609.74,107.83 608.74,104.83 610.5,101C 615.398,102.73 620.565,103.896 626,104.5C 630.294,104.852 633.96,103.518 637,100.5C 637.769,97.9009 637.602,95.4009 636.5,93C 629.717,90.6369 623.05,87.9702 616.5,85C 607.107,73.6822 609.107,64.8489 622.5,58.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f6f6",
    d: "M 538.5,59.5 C 541.448,59.2229 544.281,59.5562 547,60.5C 550.642,73.069 553.976,85.7357 557,98.5C 560,86.1667 563,73.8333 566,61.5C 569.23,59.3088 572.73,58.9755 576.5,60.5C 580.451,73.3028 583.617,86.3028 586,99.5C 589.47,87.2953 592.803,74.962 596,62.5C 596.374,61.5838 596.874,60.7504 597.5,60C 600.167,59.3333 602.833,59.3333 605.5,60C 606.022,60.5613 606.355,61.228 606.5,62C 601.19,78.0941 596.19,94.2608 591.5,110.5C 587.894,110.789 584.394,110.456 581,109.5C 577.671,97.8495 574.505,86.1828 571.5,74.5C 568.121,86.0976 564.955,97.7642 562,109.5C 558.545,110.791 555.045,110.791 551.5,109.5C 546.83,93.8232 542.163,78.1565 537.5,62.5C 537.685,61.4163 538.018,60.4163 538.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbfbfc",
    d: "M 59.5,70.5 C 69.8054,68.4139 76.9721,72.0806 81,81.5C 82.0878,89.3597 81.4211,97.0263 79,104.5C 73.7278,111.185 66.8944,113.352 58.5,111C 57.0337,110.365 55.7003,109.531 54.5,108.5C 53.5037,114.798 53.1703,121.132 53.5,127.5C 50.5,127.5 47.5,127.5 44.5,127.5C 44.5,108.833 44.5,90.1667 44.5,71.5C 47.1667,71.5 49.8333,71.5 52.5,71.5C 52.281,72.675 52.6143,73.675 53.5,74.5C 55.5654,73.1433 57.5654,71.81 59.5,70.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8f8f9",
    d: "M 101.5,70.5 C 120.608,68.7743 129.108,77.441 127,96.5C 126.059,104.774 121.559,109.94 113.5,112C 103.625,114.269 96.125,111.102 91,102.5C 88.4357,93.5132 89.1023,84.8465 93,76.5C 95.6371,74.109 98.4704,72.109 101.5,70.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8f8f9",
    d: "M 205.5,70.5 C 222.541,68.3751 230.041,75.7084 228,92.5C 219.585,93.4832 211.085,93.8166 202.5,93.5C 202.579,98.1649 204.579,101.665 208.5,104C 214.845,104.444 221.178,104.277 227.5,103.5C 227.756,105.792 227.423,107.959 226.5,110C 202.977,117.344 192.144,108.844 194,84.5C 195.873,78.1358 199.706,73.4691 205.5,70.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9f9f9",
    d: "M 298.5,93.5 C 290.167,93.5 281.833,93.5 273.5,93.5C 273.263,94.791 273.596,95.791 274.5,96.5C 275.183,100.02 277.183,102.52 280.5,104C 286.522,104.575 292.522,104.409 298.5,103.5C 298.662,105.527 298.495,107.527 298,109.5C 290.714,112.804 283.214,113.304 275.5,111C 267.794,106.755 264.461,100.255 265.5,91.5C 266.244,73.782 275.244,67.282 292.5,72C 295.728,73.5629 297.895,76.0629 299,79.5C 299.815,84.3522 299.648,89.0189 298.5,93.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7f7f8",
    d: "M 131.5,71.5 C 134.777,71.2161 137.943,71.5495 141,72.5C 143.023,81.2603 145.357,89.927 148,98.5C 148.915,97.6721 149.581,96.6721 150,95.5C 151.534,87.6979 153.534,80.0312 156,72.5C 159.565,70.9465 162.899,71.2799 166,73.5C 168.179,82.5478 170.512,91.5478 173,100.5C 175.358,91.0657 178.025,81.7323 181,72.5C 183.719,71.5562 186.552,71.2229 189.5,71.5C 185.979,84.2322 182.146,96.8988 178,109.5C 174.899,111.72 171.565,112.053 168,110.5C 165.493,101.491 162.993,92.4909 160.5,83.5C 157.677,92.459 155.01,101.459 152.5,110.5C 149.5,111.833 146.5,111.833 143.5,110.5C 139.089,97.6019 135.089,84.6019 131.5,71.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3f4f5",
    d: "M 237.5,71.5 C 239.857,71.3367 242.19,71.5034 244.5,72C 245.09,73.5095 245.756,75.0095 246.5,76.5C 250.501,72.0435 255.501,70.3768 261.5,71.5C 261.5,74.1667 261.5,76.8333 261.5,79.5C 256.266,78.8346 251.432,79.8346 247,82.5C 246.667,91.8333 246.333,101.167 246,110.5C 243.263,111.61 240.429,111.777 237.5,111C 236.175,97.8334 236.175,84.6667 237.5,71.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f6f7",
    d: "M 417.5,71.5 C 420.777,71.2161 423.943,71.5495 427,72.5C 430.07,81.876 433.236,91.2093 436.5,100.5C 439.764,91.2093 442.93,81.876 446,72.5C 449.057,71.5495 452.223,71.2161 455.5,71.5C 449.585,88.6738 443.085,105.674 436,122.5C 431.481,128.69 425.815,130.024 419,126.5C 418.333,124.833 418.333,123.167 419,121.5C 426.368,122.076 430.534,118.742 431.5,111.5C 426.248,98.3377 421.581,85.0043 417.5,71.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2d3947",
    d: "M 208.5,77.5 C 216.463,76.1419 220.463,79.4753 220.5,87.5C 214.5,87.5 208.5,87.5 202.5,87.5C 202.469,82.8868 204.469,79.5535 208.5,77.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2d3846",
    d: "M 279.5,77.5 C 287.465,76.1343 291.465,79.4677 291.5,87.5C 285.463,87.8293 279.463,87.4959 273.5,86.5C 274.778,82.912 276.778,79.912 279.5,77.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#293443",
    d: "M 58.5,77.5 C 64.8157,76.5728 69.3157,78.9061 72,84.5C 72.7511,89.5715 72.4178,94.5715 71,99.5C 68.0239,103.939 63.8572,105.439 58.5,104C 56.6711,103.727 55.1711,102.893 54,101.5C 53.3333,94.5 53.3333,87.5 54,80.5C 55.6516,79.6006 57.1516,78.6006 58.5,77.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#263241",
    d: "M 104.5,77.5 C 110.094,76.7432 114.261,78.7432 117,83.5C 118.081,90.0544 117.414,96.3877 115,102.5C 111.744,104.429 108.244,104.929 104.5,104C 102.333,103.167 100.833,101.667 100,99.5C 96.8639,91.0471 98.3639,83.7138 104.5,77.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#273241",
    d: "M 322.5,77.5 C 326.839,76.8461 330.673,77.8461 334,80.5C 334.831,87.856 334.665,95.1893 333.5,102.5C 327.705,105.729 322.539,105.062 318,100.5C 316.544,94.9034 316.211,89.2367 317,83.5C 318.36,80.9774 320.193,78.9774 322.5,77.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#263240",
    d: "M 390.5,77.5 C 396.094,76.7432 400.261,78.7432 403,83.5C 403.851,89.2531 403.517,94.9198 402,100.5C 397.385,104.973 392.219,105.64 386.5,102.5C 385.167,94.8333 385.167,87.1667 386.5,79.5C 388.026,79.0057 389.359,78.339 390.5,77.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2b3745",
    d: "M 506.5,87.5 C 511.87,87.3921 517.203,87.7255 522.5,88.5C 523.255,98.246 518.755,103.579 509,104.5C 501.186,103.208 498.852,98.8744 502,91.5C 503.397,89.9297 504.897,88.5964 506.5,87.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5f6772",
    d: "M 298.5,93.5 C 290.281,93.8459 282.281,94.8459 274.5,96.5C 273.596,95.791 273.263,94.791 273.5,93.5C 281.833,93.5 290.167,93.5 298.5,93.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f39306",
    d: "M 634.5,122.5 C 652.725,118.121 658.558,124.454 652,141.5C 650.333,147.192 646.999,151.526 642,154.5C 641.5,154.167 641,153.833 640.5,153.5C 643.704,146.411 645.537,139.078 646,131.5C 642.843,130.119 639.509,129.452 636,129.5C 618.752,131.302 618.252,128.969 634.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f79503",
    d: "M 483.5,126.5 C 490.466,128.479 497.132,131.312 503.5,135C 538.176,149.443 573.843,152.443 610.5,144C 620.023,140.566 629.689,137.732 639.5,135.5C 639.919,138.325 638.919,140.491 636.5,142C 589.731,168.63 543.398,167.963 497.5,140C 494.833,138 492.167,136 489.5,134C 486.882,131.894 484.882,129.394 483.5,126.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAws);
export default __webpack_public_path__ + "static/media/aws.6715b7aae959f37507d24ca7b866d101.svg";
export { ForwardRef as ReactComponent };